import PropTypes from 'prop-types';
import React from 'react';

import LoadingStore from '../../stores/LoadingStore';
import connectToStores from '../../helpers/connectToStores';

import PureRenderComponent from '../PureRenderComponent';


function _getStateFromStores () {
    return {
        loading: LoadingStore.isLoading()
    };
}


@connectToStores([ LoadingStore ], _getStateFromStores)
class LoadingLine extends PureRenderComponent {

    static propTypes = {
        loading: PropTypes.bool
    };

    static defaultProps = {
        loading: false
    };

    render () {
        if (this.props.loading) {
            return (
                <div className="loading-line">
                    <div className="break dot1" />
                    <div className="break dot2" />
                    <div className="break dot3" />
                </div>
            );
        }
        return null;
    }

}


export default LoadingLine;
